var SiteTracker = require('./aa.js');
var isProd = process.env.NODE_ENV == 'production' ? true : false;
var config = require('./config.js');
var util = require('./util.js')
const hostname = typeof location === 'object' ? location.hostname : ''
const platform = /\.58/.test(hostname) ? 'wuba' : 'anjuke'

module.exports = {
    pageName: '',
    sendSoj: function (action, customparam, type, site, plat, page, exposureparams) {
        var _site = platform,
            soj = new SiteTracker(),
            t_params;
        var pageName = this.pageName;
        soj.setCustomParam(customparam);
        soj.setExposureparams(exposureparams || '{}');
        if (!isProd) {
            t_params = {
                'target_url': config.devSojURL
            }
        }
        soj.setPage(pageName);
        //soj.setPageName(action||'');
        soj.setSite(_site);
        soj.setScreen(util.getScreen());
        soj.setReferer(document.referrer);

        soj.setPlat(plat || 2);
        //这里是为了兼容业务代码中利用sendsoj直接发pv,如二手房单页
        if (!type) {
            type = 1;
            soj.setPage(action);
        }
        soj.setType(type);

        if (action && typeof action == 'string' && action.length > 0)
            soj.setAction(action);

        soj.track(t_params);
        if (type == 1) {
            var _trackURL = soj.getParams();
            delete _trackURL.cp;
            delete _trackURL.sc;
            window._trackURL = JSON.stringify(_trackURL);
            var _ckurl = window._trackURL = JSON.stringify(_trackURL);
            loadTrackjs();
        }

        function loadTrackjs() {
            var s = document.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = location.protocol + '//tracklog.58.com/referrer_anjuke_m.js?_=' + Math.random();
            var b = document.body;
            b.appendChild(s);
        }
    },
    trackEvent: function (action, customparam, type, exposureparams) {
        var cp = customparam,
            ep = exposureparams;
        if (util.isPlainObject(customparam)) {
            cp = JSON.stringify(customparam);
        }
        if (util.isPlainObject(exposureparams)) {
            ep = JSON.stringify(exposureparams);
        }
        this.sendSoj(action, cp, type || 2, '', '', '', ep);
    },
    sendPv: function (pageName, cp) {
        this.pageName = pageName;
        this.sendSoj('', JSON.stringify(cp), 1);
    }
}
